// extracted by mini-css-extract-plugin
export default {"loader":"DSPLoader_loader__uPEcT","dot":"DSPLoader_dot__hig42","dsp-loader":"DSPLoader_dsp-loader__cFYKz"};